import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseControl } from '@app/shared';

@Injectable()
export class FormControlService {
  constructor() {}

  /**
   * Crea un formulario con los controles especificados.
   *
   * @param {BaseControl<any>[]} elements
   * @returns {FormGroup}
   * @memberof FormControlService
   */
  createFormGroup(elements: BaseControl<any>[]): FormGroup {
    const notInclude = ['legend'];
    const allElements: BaseControl<any>[] = [];
    elements.forEach(el => {
      if (el.controlType === 'container') {
        const allSubElements: BaseControl<any>[] = this.getAllControls(el['controls']);
        allSubElements.forEach(element => allElements.push(element));
      } else {
        if (!notInclude.includes(el.controlType)) {
          if (el.controlType) {}
          allElements.push(el);
        }
      }
    });
    const controls = this.createControls(allElements);
    return new FormGroup(controls);
  }

  /**
   * Consulta de todos los controles
   * Nota: esta consulta se realiza para consultar los controles dentro de los contenedores
   *
   * @param {BaseControl<any>[]} elements
   * @returns {BaseControl<any>[]}
   * @memberof FormControlService
   */
  getAllControls(elements: BaseControl<any>[]): BaseControl<any>[] {
    const notInclude = ['legend'];
    const allElements: BaseControl<any>[] = [];
    elements.forEach(el => {
      if (el.controlType === 'container') {
        const allSubElements: BaseControl<any>[] = this.getAllControls(el['controls']);
        allSubElements.forEach(element => allElements.push(element));
      } else {
        if (!notInclude.includes(el.controlType)) {
          if (el.controlType) {}
          allElements.push(el);
        }
      }
    });
    return allElements;
  }

  /**
   * Genera cada control del formulario en base a la
   * configuración dada a través de la clase "BaseControl".
   *
   * @private
   * @param {any[]} elements
   * @returns objeto con los controles del formulario. Ie, {key:Control}
   * @memberof FormControlService
   */
  private createControls(elements: BaseControl<any>[]) {
    const group: any = {};

    if (elements) {
      elements.forEach(el => {
        if (!el.value && el.controlType === 'dropdown') {
          el.value = '';
        } else if (typeof el.value !== 'boolean' && el.controlType === 'textbox' && el['type'] === 'checkbox') {
          if (el['default']) {
            el.value = el['default'];
          } else {
            el.value = false;
          }
        }
        if (el.validations && el.validations.validators) {
          group[el.key] = new FormControl(
            {
              value: el.value,
              disabled: el.disabled
            },
            Validators.compose(el.validations.validators)
          );
        } else {
          group[el.key] = new FormControl({
            value: el.value,
            disabled: el.disabled
          });
        }
      });
    }
    return group;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/form-control.service.ts